/**
 * @file ErrorPage.jsx
 *
 * @version 1.0.0
 * @author Carmelino Galang
 * @copyright Copyright (c) 2024, NetCyberOps LLC
 */
import React from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

import "./ErrorPage.css";

import NavLogo from "@assets/logos/nav-logo4.svg";

export default function Error() {
  return (
    <div className="error-page-wrapper pt-5">
      <Image src={NavLogo} className="landing-logo mb-5" fluid />
      <h1>Oops! An error occurred</h1>
      <Link to="/" className="mt-3">
        <h4>Return to Homepage</h4>
      </Link>
    </div>
  );
}
